import { IS_HEBREW } from './locale';

export const Regex = {
  EMAIL: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
  PHONE: /^\+\d{1,3} [\d\s\-()]*$/,
  PHONE_INVALID: /invalid phone number$/,
  PHONE_PATTERN: IS_HEBREW ? '$1-$2-$3' : '($1) $2-$3',
  PHONE_RAW: IS_HEBREW ? /^(5[0-9])([0-9]{3})([0-9]{4})$/ : /^([0-9]{3})([0-9]{3})([0-9]{4})$/,
  YEAR: /^[0-9]{4}$/,
};
